/**
 * bt-off-canvas.js – v3 (multi‑trigger)
 * Luke @ Bayside Technology
 */
/* SIMPLE SCOPED TABS (v4) ------------------------------------------- */
function btOpenTab(id, btn) {
  // 1️⃣  Find the nearest .bt-tab-buttons (the button row you clicked in)
  const buttonsGroup = btn.closest('.bt-tab-buttons');
  if (!buttonsGroup) return;          // safety guard

  // 2️⃣  Highlight the clicked button, un-highlight siblings
  buttonsGroup.querySelectorAll('.bt-tab-button')
              .forEach(b => b.classList.toggle('bt-active', b === btn));

  // 3️⃣  Show the matching pane; hide other .bt-tab-content
  const wrapper = buttonsGroup.parentElement;  // siblings live here
  Array.from(wrapper.children)
       .filter(el => el.classList?.contains('bt-tab-content'))
       .forEach(el => el.classList.toggle('bt-active', el.id === id));
}

document.addEventListener('DOMContentLoaded', () => {
  
  document.querySelectorAll('.bt-off-canvas').forEach(section => {
    /* ------ Lấy danh sách trigger ------ */
    const raw = (section.dataset.btTriggerTexts || '').replace(/[\n\r]+/g, ',');
    const triggerArr = raw.split(',')
                          .map(t => t.trim().toLowerCase())
                          .filter(Boolean);          // loại dấu phẩy thừa

    const openInEditor = section.dataset.btOpenInEditor === 'true';
    const panel   = section.querySelector('.bt-off-canvas__panel');
    const closeBtn = panel.querySelector('.bt-off-canvas__close');

    /* ------ Helpers ------ */
    const lockBody = () => {
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    };
    const unlockBody = () => {
      const y = parseInt(document.body.style.top || '0') * -1;
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, y);
    };
    const openPanel = () => {
      panel.classList.add('bt-off-canvas__panel--open');
      panel.setAttribute('aria-hidden', 'false');
      lockBody();
      closeBtn.focus();
    };
    const closePanel = () => {
      panel.classList.remove('bt-off-canvas__panel--open');
      panel.setAttribute('aria-hidden', 'true');
      unlockBody();
    };

    /* ------ Close events ------ */
    closeBtn.addEventListener('click', closePanel);
    panel.addEventListener('click', e => { if (e.target === panel) closePanel(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && panel.classList.contains('bt-off-canvas__panel--open')) closePanel();
    });

    /* ------ Scan & bind triggers ------ */
    const bindTriggers = root => {
      if (!triggerArr.length) return;
      const candidates = root.querySelectorAll('a, button, [role="button"], input[type="button"], input[type="submit"], span, div');
      candidates.forEach(el => {
        if (el.dataset.btBound) return;
        const txt = (el.textContent || '').trim().toLowerCase();
        if (triggerArr.includes(txt)) {
          el.dataset.btBound = 'true';
          el.classList.add('bt-off-canvas__external-trigger');
          el.addEventListener('click', e => {
            e.preventDefault();
            openPanel();
          });
        }
      });
    };

    // Lần quét đầu
    bindTriggers(document);

    // Quan sát DOM mới thêm
    const observer = new MutationObserver(mutations => {
      mutations.forEach(m => m.addedNodes.forEach(n => n.nodeType === 1 && bindTriggers(n)));
    });
    observer.observe(document.body, { childList: true, subtree: true });

    /* ------ Auto‑open trong editor ------ */
    if (openInEditor && window.Shopify && Shopify.designMode) openPanel();
  });
});

/* CHANGE TIMEFRAME OF PRODUCTS IN PURCHASE NOTICE #SLA-392751  */
const handlesToUpdate = [
  '/products/paperclip-chain-silver',
  '/products/paperclip-chain-gold',
  '/products/paperclip-bracelet-silver',
  '/products/paperclip-bracelet-gold',
  '/products/chunky-mixed-links-belcher-chain-silver-6-5mm',
  '/products/chunky-mixed-links-belcher-chain-gold-6-5mm',
  '/products/chunky-mixed-links-belcher-bracelet-silver-6-5mm',
  '/products/chunky-mixed-links-belcher-bracelet-gold-6-5mm',
  '/products/mixed-links-belcher-chain-silver-5-5mm',
  '/products/mixed-links-belcher-chain-gold-5-5mm',
  '/products/mixed-links-belcher-bracelet-silver-5-5mm',
  '/products/mixed-links-belcher-bracelet-gold-5-5mm',
  '/products/bold-belcher-chain-silver-3-4mm',
  '/products/bold-belcher-chain-gold-3-4mm',
  '/products/bold-belcher-bracelet-silver-3-4mm',
  '/products/bold-belcher-bracelet-gold-3-4mm',
  '/products/fine-multi-gemstone-ring-gold',
  '/products/fine-multi-gemstone-ring-silver',
  '/products/fine-birthstone-ring-gold-multi-stone',
  '/products/fine-birthstone-ring-silver-multi-stone',
  '/products/fine-colourway-ring-gold',
  '/products/fine-colourway-ring-silver'
];

document.addEventListener('DOMContentLoaded', () => {
  const currentPath = window.location.pathname.replace(/\/$/, '');

  if (!handlesToUpdate.includes(currentPath)) return;

  document
    .querySelectorAll('.purchase_notice .metafield-rich_text_field p')
    .forEach((p) => {
      if (/3\s*-\s*4\s*weeks/i.test(p.textContent)) {
        p.textContent = p.textContent.replace(/3\s*-\s*4\s*weeks/i, '4-5 weeks');
      }
    });
});


(function () {
  // Map stone names to image urls
  const stoneImageMap = {
    'Sapphire Cornflower Blue': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/SapphireCornflowerBlue.jpg',
    'Topaz Blue': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/TopazBlue.jpg',
    'Alexandrite': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Alexandrite.jpg',
    'Sapphire Teal': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/SapphireTeal.jpg',
    'Tanzanite': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Tanzanite.jpg',
    'Peridot': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Peridot.jpg',
    'Amethyst': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Amethyst.jpg',
    'Emerald': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Emerald.jpg',
    'Tourmaline Green': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/TourmalineGreen.jpg',
    'Tourmaline Pink': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/TourmalinePink.jpg?v=1763510508',
    'Aquamarine': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Aquamarine.jpg',
    'Opal': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Opal.jpg',
    'Garnet': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Garnet.jpg',
    'Pearl': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Pearl.jpg',
    'Diamond': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Diamond.jpg',
    'Ruby': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Ruby.jpg',
    'Citrine': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Citrine.jpg',
    'Sapphire': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Sapphire.jpg',
    'Pink Sapphire': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/TourmalinePink.jpg?v=1763510508',
    'Purple Sapphire': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Amethyst.jpg',
    'Moissanite': 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/Diamond.jpg',
    'Moonstone' : 'https://cdn.shopify.com/s/files/1/0558/8149/8764/files/moonstone.jpg?v=1766564303'
  };

  // Map stone names to months
  const stoneMonthMap = {
    'Garnet': 'January',
    'Amethyst': 'February',
    'Aquamarine': 'March',
    'Moissanite': 'April',
    'Diamond': 'April',
    'Emerald': 'May',
    'Pearl': 'June',
    'Alexandrite': 'June',
    'Ruby': 'July',
    'Peridot': 'August',
    'Sapphire': 'September',
    'Sapphire Cornflower Blue': 'September',
    'Sapphire Teal': 'September',
    'Pink Sapphire': 'September',
    'Purple Sapphire': 'September',
    'Blue Sapphire': 'September',
    'Opal': 'October',
    'Tourmaline Green': 'October',
    'Tourmaline Pink': 'October',
    'Citrine': 'November',
    'Topaz Blue': 'December',
    'Tanzanite': 'December',
    'Moonstone' : 'June'
  };

  

  function injectStyles() {
  if (document.getElementById("stone-small-styles")) return;

  const styleEl = document.createElement("style");
  styleEl.id = "stone-small-styles";
  styleEl.textContent = `
    div[data-name*="Stone"] .ymq-price-in-option-value{
      opacity: 1 !important;
    }

    div[data-name*="Stone"] .ymq-price-span{
      color: var(--link-color);
    }

    /* Grid look with perfect borders, no double borders */
    div[data-name*="Stone"] .ymq-multiple-ul{
      display: flex !important;
      flex-wrap: wrap !important;

      /* TEST RED LINES */
      background: #f6f2ef !important;
      border: 1.5px solid #f6f2ef !important;

      gap: 1px !important;

      box-sizing: border-box;
    }


    div[data-name*="Stone"] .ymq-dropdown ul li.ymq-multiple-li{
      display: flex !important;
      flex-direction: column !important;

      flex: 1 0 var(--bt-stone-col-width, calc((100% - 4px) / 3));
      max-width: var(--bt-stone-col-width, calc((100% - 4px) / 3));

      border: 0 !important;
      background: #fff !important;

      padding: 10px !important;
      box-sizing: border-box;
    }
    div[data-name*="Stone"] .ymq-dropdown ul li.ymq-multiple-li{
      outline: 1px solid #f6f2ef !important;
      outline-offset: 0 !important;
    }
    div[data-name*="Stone"] .ymq-dropdown ul li.ymq-multiple-li a{
      display: flex;
      justify-content: flex-start !important;
      align-items: center;
      padding: 0 !important;
      flex-direction: column;
      height: 100%;
      width: 100%;
      text-align: center;
    }

    div[data-name*="Stone"] .ymq-dropdown ul li.ymq-multiple-li .stone-small-img{
      display: block;
      width: 100%;
      height: auto;
      aspect-ratio: 1;
      margin: 0 auto 10px auto;
      border: #e8e8e8 solid 1px;
      background-size: 150% 150%;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 2px;
    }

    div[data-name*="Stone"] .ymq-price-in-option-value{
      opacity: 0.5;
    }

    div[data-name*="Stone"] div.ymq-dropdown ul li.ymq-multiple-li.active:hover .ymq-price-in-option-value{
      padding-right: 0px !important;
    }

    div[data-name*="Stone"] .ymq-multiple-li a .ymq-option-value{
      text-transform: capitalize !important;
    }

    /* optional responsive */
    @media (max-width: 640px){
      div[data-name*="Stone"] .ymq-dropdown ul li.ymq-multiple-li{
        flex-basis: calc((100% - 1px) / 2) !important;
        max-width: calc((100% - 1px) / 2) !important;
      }
    }

    @media (max-width: 420px){
      div[data-name*="Stone"] .ymq-dropdown ul li.ymq-multiple-li{
        flex-basis: calc((100% - 1px) / 2) !important;
        max-width: calc((100% - 1px) / 2) !important;
      }
    }
  `;
  document.head.appendChild(styleEl);
}


// Usage:

function addStoneImagesAndMonths({ boldTerms = [] } = {}) {
  const containers = document.querySelectorAll('div[data-name*="Stone"]');

  const escapeRegExp = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const toTitleCaseKeepNumbers = (str) =>
    String(str || "")
      .toLowerCase()
      .replace(/\b([a-z])([a-z']*)\b/g, (_, a, b) => a.toUpperCase() + b);

  const enhanceText = (text, { breakAfterPlus = true } = {}) => {
    let out = String(text || "");

    out = toTitleCaseKeepNumbers(out);

    // only add <br> for list items, not for the outside label
    if (breakAfterPlus) {
      out = out.replace(/\s*\+\s*/g, " +<br> ");
    } else {
      out = out.replace(/\s*\+\s*/g, " + ");
    }

    const terms = [...boldTerms]
      .filter(Boolean)
      .map(toTitleCaseKeepNumbers)
      .sort((a, b) => b.length - a.length);

    for (const term of terms) {
      const re = new RegExp(escapeRegExp(term), "g");
      out = out.replace(re, (m) => `<strong>${m}</strong>`);
    }

    return out.trim();
  };

  const applyToSelectedLabel = (container) => {
    // outside label: NO line break after "+"
    container
      .querySelectorAll(".ymq-dropdown > span .ymq-option-value, .ymq_option_text_span")
      .forEach((el) => {
        const raw = el.dataset.rawText || (el.dataset.rawText = el.textContent.trim());
        el.innerHTML = enhanceText(raw, { breakAfterPlus: false });
      });
  };
  const monthNamesRe = /\b(january|february|march|april|may|june|july|august|september|october|november|december)\b/ig;

const cleanStoneName = (s) => {
  let out = String(s || "");
  // remove anything after a plus sign, like "Pink Sapphire + $140.00"
  out = out.replace(/\s*\+\s*.*$/g, "");
  // remove month words if they got merged into textContent
  out = out.replace(monthNamesRe, "");
  // collapse whitespace
  out = out.replace(/\s+/g, " ").trim();
  return out;
};

// longest keys first so "Pink Sapphire" matches before "Sapphire"
const imageKeysByLength = Object.keys(stoneImageMap).sort((a, b) => b.length - a.length);
const monthKeysByLength = Object.keys(stoneMonthMap).sort((a, b) => b.length - a.length);
  containers.forEach((container) => {
    const items = container.querySelectorAll("li.ymq-multiple-li");

    // Tinh chỉnh grid cột tuỳ vào số lượng stones để không bị 1-2 cục trơ trọi
    if (items.length === 16) {
      container.style.setProperty('--bt-stone-col-width', 'calc((100% - 4px) / 4)');
    } else {
      container.style.setProperty('--bt-stone-col-width', 'calc((100% - 4px) / 3)');
    }

    const processLi = (li) => {
  const link = li.querySelector("a");
  if (!link) return;

  const optionSpan = link.querySelector(".ymq-option-value");

  // prefer aria label or title if present, then fallback to text
  const labelFromImg =
    li.querySelector(".stone-small-img")?.getAttribute("aria-label") ||
    li.querySelector(".stone-small-img")?.getAttribute("title") ||
    "";

  const rawName = optionSpan
    ? (optionSpan.dataset.rawText || (optionSpan.dataset.rawText = optionSpan.textContent.trim()))
    : (labelFromImg || link.textContent);

  const stoneName = cleanStoneName(rawName);
  if (!stoneName) return;

  // IMAGE: always set, even if stone-small-img already exists
  let imgSrc = stoneImageMap[stoneName];

  if (!imgSrc) {
    const lowerName = stoneName.toLowerCase();
    for (const key of imageKeysByLength) {
      if (lowerName.includes(key.toLowerCase())) {
        imgSrc = stoneImageMap[key];
        break;
      }
    }
  }

  if (imgSrc) {
    let imgDiv = link.querySelector(".stone-small-img");
    if (!imgDiv) {
      imgDiv = document.createElement("div");
      imgDiv.className = "stone-small-img";
      imgDiv.setAttribute("role", "img");
      link.insertBefore(imgDiv, link.firstChild);
    }
    imgDiv.style.backgroundImage = `url("${imgSrc}")`;
    imgDiv.setAttribute("aria-label", stoneName);
    imgDiv.title = stoneName;
  }

  // MONTH
  let monthText = stoneMonthMap[stoneName];

  if (!monthText) {
    const lowerName = stoneName.toLowerCase();
    for (const key of monthKeysByLength) {
      if (lowerName.includes(key.toLowerCase())) {
        monthText = stoneMonthMap[key];
        break;
      }
    }
  }

  // CHECK BIRTHSTONE TAGS
  // Only append month text if product has 'birthstone' or 'birthstones' tag
  const productTags = window.argentProductTags || [];
  const hasBirthstoneTag = productTags.some(tag => {
    const t = tag.toLowerCase().trim();
    return t === 'birthstone' || t === 'birthstones';
  });

  if (hasBirthstoneTag && monthText) {
    const priceSpan =
      link.querySelector(".ymq-price-in-option-value") ||
      link.querySelector(".ymq-price-span");

    if (priceSpan) {
      priceSpan.innerHTML = enhanceText(monthText, { breakAfterPlus: true });
    }
  }
};


    items.forEach(processLi);
    applyToSelectedLabel(container);

    container.addEventListener(
      "click",
      (e) => {
        const li = e.target.closest("li.ymq-multiple-li");
        if (!li || !container.contains(li)) return;

        processLi(li);

        requestAnimationFrame(() => applyToSelectedLabel(container));
      },
      true
    );
  });
}




    // keep this as is
  function runMain() {
    injectStyles();
    addStoneImagesAndMonths({ boldTerms: ["NO STONES", "SMALL", "LARGE", "1","3 ", "2 SMALL"] });
  }

  // new: schedule three runs after DOM is ready
  function scheduleRuns() {
    setTimeout(runMain, 1500); // 1.5 seconds
    setTimeout(runMain, 2000); // 2 seconds
    setTimeout(runMain, 2500); // 2.5 seconds
  }

  // activate based on DOM readiness instead of a key sequence
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRuns);
  } else {
    scheduleRuns();
  }
})();

  //Manual Trigger

  // let activated = false;
  // function activateScript() {
  //   if (activated) return;
  //   activated = true;

  //   if (document.readyState === 'loading') {
  //     document.addEventListener('DOMContentLoaded', runMain);
  //   } else {
  //     runMain();
  //   }
  // }
  
  // let keyBuffer = '';
  // const triggerWord = 'aaaaa';

  // document.addEventListener('keydown', function (e) {
  //   if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
  //     keyBuffer += e.key.toLowerCase();

  //     if (keyBuffer.length > triggerWord.length) {
  //       keyBuffer = keyBuffer.slice(-triggerWord.length);
  //     }

  //     if (keyBuffer === triggerWord) {
  //       activateScript();
  //     }
  //   }
  // });
// })();

